import axios from "../../axios";
import {
  GET_LIST_CHECKIN, GET_ORDER_DETAIL, GET_LIST_ORDER_HISTORY, GET_REPORT_CHECKIN, REMOVE_CHECKIN_ITEM, GET_LIST_TIME_KEEPING, ADD_TIME_KEEPING, REMOVE_TIME_KEEPING,
  UPDATE_TIME_KEEPING, GET_PAYROLL_LIST, GET_PAYROLL_SETTING, APPROVE_PAYROLL, UPDATE_PAYROLL_SETTING, GET_DISCOUNT_SETTING, UPDATE_DISCOUNT_SETTING, GET_INCOME_DETAIL,
  GET_APPROVE_PAYROLL, EXPORT_PAYROLL, EXPORT_APPROVE_PAYROLL, EXPORT_INCOME_DETAIL, GET_TICKET_LIST, GET_BLOCK_LIST, CREATE_TICKET_TEMPLATE, DELETE_TICKET_TEMPLATE,
  UPDATE_TICKET_TEMPLATE, MOVE_SUBJECT, SET_DEFAULT_TICKET_TEMPLATE, GET_SALARY_CHART, UPDATE_ORDER_STAFF, CHECK_PASSWORD, GET_CASH_DISCOUNT_SETTING, UPDATE_CASH_DISCOUNT_SETTING,
  GET_BATCH_HISTORY, GET_BATCH_DETAIL, GET_INCOME_HISTORY, REMOVE_ORDER, EXPORT_ORDER, CHECK_GIFTCARD, CALCULATE_ORDER, UPDATE_ORDER, RESET_GIFT_CARD, CANCEL_ORDER, GET_STAFF_DAILY_INCOME,
  GET_SALARY_DETAIL
} from './goPosTypes'
import {
  URL_GET_LIST_CHECKIN, URL_GET_ORDER_DETAIL, URL_GET_LIST_ORDER_HISTORY, URL_GET_REPORT_CHECKIN, URL_REMOVE_CHECKIN_ITEM, URL_GET_LIST_TIME_KEEPING, URL_ADD_TIME_KEEPING, URL_REMOVE_TIME_KEEPING,
  URL_UPDATE_TIME_KEEPING, URL_GET_PAYROLL_LIST, URL_GET_PAYROLL_SETTING, URL_APPROVE_PAYROLL, URL_UPDATE_PAYROLL_SETTING, URL_GET_DISCOUNT_SETTING, URL_UPDATE_DISCOUNT_SETTING,
  URL_GET_INCOME_DETAIL, URL_GET_APPROVE_PAYROLL, URL_EXPORT_PAYROLL, URL_EXPORT_APPROVE_PAYROLL, URL_EXPORT_INCOME_DETAIL, URL_GET_TICKET_LIST, URL_GET_BLOCK_LIST, URL_CREATE_TICKET_TEMPLATE,
  URL_DELETE_TICKET_TEMPLATE, URL_UPDATE_TICKET_TEMPLATE, URL_MOVE_SUBJECT, URL_SET_DEFAULT_TICKET_TEMPLATE, URL_GET_SALARY_CHART, URL_UPDATE_ORDER_STAFF, URL_CHECK_PASSWORD,
  URL_GET_CASH_DISCOUNT_SETTING, URL_UPDATE_CASH_DISCOUNT_SETTING, URL_GET_BATCH_HISTORY, URL_GET_BATCH_DETAIL, URL_GET_INCOME_HISTORY, URL_REMOVE_ORDER, URL_EXPORT_ORDER, URL_CHECK_GIFTCARD, URL_CALCULATE_ORDER,
  URL_UPDATE_ORDER, URL_RESET_GIFT_CARD, URL_CANCEL_ORDER, URL_GET_STAFF_DAILY_INCOME, URL_GET_SALARY_DETAIL
} from './goPosUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'

export default {
  [GET_LIST_CHECKIN]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_LIST_CHECKIN}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_LIST_CHECKIN, data);
              resolve(data);
            } else {
              commit(GET_LIST_CHECKIN, {});
              reject(resultModel.message)
            }
          } else {
            commit(GET_LIST_CHECKIN, {});
            reject(responseModel.message)
          }
        })
        .catch((error) => { reject(error); })
    })
  },
  [GET_ORDER_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_ORDER_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_ORDER_DETAIL, data);
              resolve(data);
            } else {
              commit(GET_ORDER_DETAIL, {});
              reject(resultModel.message)
            }
          } else {
            commit(GET_ORDER_DETAIL, {});
            reject(responseModel.message)
          }
        })
        .catch((error) => { reject(error); })
    })
  },
  [GET_LIST_ORDER_HISTORY]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_LIST_ORDER_HISTORY}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_LIST_ORDER_HISTORY, data);
              resolve(data);
            } else {
              commit(GET_LIST_ORDER_HISTORY, {});
              reject(resultModel.message)
            }
          } else {
            commit(GET_LIST_ORDER_HISTORY, {});
            reject(responseModel.message)
          }
        })
        .catch((error) => { reject(error); })
    })
  },
  [GET_REPORT_CHECKIN]({ commit }, item) {
    item.type = item.payment_type;
    delete item.payment_type;
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_REPORT_CHECKIN}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_REPORT_CHECKIN, data);
              resolve(data);
            } else {
              commit(GET_REPORT_CHECKIN, {});
              reject(resultModel.message)
            }
          } else {
            commit(GET_REPORT_CHECKIN, {});
            reject(responseModel.message)
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  [REMOVE_CHECKIN_ITEM]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_REMOVE_CHECKIN_ITEM}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_LIST_CHECKIN, item)
              dispatch(GET_REPORT_CHECKIN, item)
              resolve(data);
            } else {
              if (resultModel.message && resultModel.message) {
                reject(resultModel.message);
              } else {
                let data = resultModel.data;
                dispatch(GET_LIST_CHECKIN, item)
                dispatch(GET_REPORT_CHECKIN, item)
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [REMOVE_ORDER]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_REMOVE_ORDER}`, data)
        .then(async (response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            await dispatch(GET_LIST_CHECKIN, item);
            dispatch(GET_REPORT_CHECKIN, item);
            resolve(responseModel.data);
            // let resultModel = responseModel.result;
            // if (resultModel.status == STATUS_OK) {
            //   let data = resultModel.data;
            //   dispatch(GET_LIST_CHECKIN, item)
            //   dispatch(GET_REPORT_CHECKIN, item)
            //   resolve(data);
            // } else {
            //   if (resultModel.message && resultModel.message) {
            //     reject(resultModel.message);
            //   } else {
            //     let data = resultModel.data;
            //     dispatch(GET_LIST_CHECKIN, item)
            //     dispatch(GET_REPORT_CHECKIN, item)
            //     resolve(data);
            //   }
            // }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [CANCEL_ORDER]({ dispatch }, item) {
    let data = new FormData();
    // for (var key in item) {
    //   data.append(key, item[key]);
    // }
    data.append("order_id", item.order_id);
    return new Promise((resolve, reject) => {
      axios.post(URL_CANCEL_ORDER, data)
        .then(async (response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            await dispatch(GET_LIST_CHECKIN, item);
            dispatch(GET_REPORT_CHECKIN, item);
            resolve(responseModel.data);
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [EXPORT_ORDER]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_ORDER}${param}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) })
    })
  },

  // eslint-disable-next-line
  [CHECK_GIFTCARD]({ commit }, item) {
    // let data = new FormData();
    // for (var key in item) {
    //   data.append(key, item[key]);
    // }
    return new Promise((resolve, reject) => {
      axios.get(`${URL_CHECK_GIFTCARD}`, {params: item})
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(CHECK_GIFTCARD, data);
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [CALCULATE_ORDER]({ commit }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CALCULATE_ORDER}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(CALCULATE_ORDER, data);
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_ORDER]({ commit }, item) {
    // let data = new FormData();
    // for (var key in item) {
    //   data.append(key, item[key]);
    // }
    let data = item;
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_ORDER}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [RESET_GIFT_CARD]({ commit }, item) {
    // let data = new FormData();
    // for (var key in item) {
    //   data.append(key, item[key]);
    // }
    let data = item;
    return new Promise((resolve, reject) => {
      axios.post(`${URL_RESET_GIFT_CARD}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [CHECK_PASSWORD]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CHECK_PASSWORD}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_ORDER_STAFF]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_ORDER_STAFF}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                id: item.order_id
              }
              dispatch(GET_ORDER_DETAIL, temp);
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  //time-keeping
  [GET_LIST_TIME_KEEPING]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_LIST_TIME_KEEPING}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_LIST_TIME_KEEPING, data);
              resolve(data);
            } else {
              commit(GET_LIST_TIME_KEEPING, {});
              reject(resultModel.message)
            }
          } else {
            commit(GET_LIST_TIME_KEEPING, {});
            reject(responseModel.message)
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  [ADD_TIME_KEEPING]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_TIME_KEEPING}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page: item.page,
                'per-page': item["per-page"],
                filter_staff_id: item.filter_staff_id,
                staff_name: item.staff_name,
                // created_from: item.created_from,
                // created_to: item.created_to,
                // checkin_from: item.checkin_from,
                // checkout_to: item.checkout_to
              }
              if (item.created_from) {
                temp.created_from = item.created_from;
              }
              if (item.created_to) {
                temp.created_to = item.created_to;
              }
              if (item.checkin_from) {
                temp.checkin_from = item.checkin_from;
              }
              if (item.checkout_to) {
                temp.checkout_to = item.checkout_to;
              }
              dispatch(GET_LIST_TIME_KEEPING, temp)
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_TIME_KEEPING]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_TIME_KEEPING}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                page: item.page,
                'per-page': item["per-page"],
                filter_staff_id: item.filter_staff_id,
                staff_name: item.staff_name,
                // created_from: item.created_from,
                // created_to: item.created_to,
                // checkin_from: item.checkin_from,
                // checkout_to: item.checkout_to
              }
              if (item.created_from) {
                temp.created_from = item.created_from;
              }
              if (item.created_to) {
                temp.created_to = item.created_to;
              }
              if (item.checkin_from) {
                temp.checkin_from = item.checkin_from;
              }
              if (item.checkout_to) {
                temp.checkout_to = item.checkout_to;
              }
              dispatch(GET_LIST_TIME_KEEPING, temp)
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [REMOVE_TIME_KEEPING]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_REMOVE_TIME_KEEPING}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  //payroll
  [GET_PAYROLL_LIST]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_PAYROLL_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_PAYROLL_LIST, data);
              resolve(data);
            } else {
              commit(GET_PAYROLL_LIST, {});
              reject(resultModel.message);
            }
          } else {
            commit(GET_PAYROLL_LIST, {});
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },
  [GET_PAYROLL_SETTING]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_PAYROLL_SETTING}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_PAYROLL_SETTING, data);
              resolve(data);
            } else {
              commit(GET_PAYROLL_SETTING, {});
              reject(resultModel.message);
            }
          } else {
            commit(GET_PAYROLL_SETTING, {});
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },
  // eslint-disable-next-line
  [APPROVE_PAYROLL]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_APPROVE_PAYROLL}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // let temp = {
              //   start_date: item.filter_start_date,
              //   end_date: item.filter_end_date
              // }
              // dispatch(GET_PAYROLL_LIST, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [UPDATE_PAYROLL_SETTING]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_PAYROLL_SETTING}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // let temp = {
              //   page : item.page,
              //   'per-page' : item["per-page"],
              //   filter_staff_id : item.filter_staff_id,
              //   created_from : item.created_from,
              //   created_to : item.created_to,
              //   checkin_from : item.checkin_from,
              //   checkout_to : item.checkout_to
              // }
              // dispatch(GET_LIST_TIME_KEEPING, temp)
              // dispatch(GET_PAYROLL_SETTING);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_DISCOUNT_SETTING]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_DISCOUNT_SETTING}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_DISCOUNT_SETTING, data);
              resolve(data);
            } else {
              commit(GET_DISCOUNT_SETTING, {});
              reject(resultModel.message);
            }
          } else {
            commit(GET_DISCOUNT_SETTING, {});
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  [UPDATE_DISCOUNT_SETTING]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_DISCOUNT_SETTING}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_DISCOUNT_SETTING);
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_CASH_DISCOUNT_SETTING]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CASH_DISCOUNT_SETTING}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CASH_DISCOUNT_SETTING, data);
              resolve(data);
            } else {
              commit(GET_CASH_DISCOUNT_SETTING, {});
              reject(resultModel.message);
            }
          } else {
            commit(GET_CASH_DISCOUNT_SETTING, {});
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  [UPDATE_CASH_DISCOUNT_SETTING]({ dispatch }, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_CASH_DISCOUNT_SETTING}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_CASH_DISCOUNT_SETTING);
              resolve(data);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_INCOME_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_INCOME_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_INCOME_DETAIL, data);
              resolve(data);
            } else {
              commit(GET_INCOME_DETAIL, {});
              reject(resultModel.message);
            }
          } else {
            commit(GET_INCOME_DETAIL, {});
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  [GET_APPROVE_PAYROLL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_APPROVE_PAYROLL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_APPROVE_PAYROLL, data);
              resolve(data);
            } else {
              commit(GET_APPROVE_PAYROLL, []);
              reject(resultModel.message);
            }
          } else {
            commit(GET_APPROVE_PAYROLL, []);
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  // eslint-disable-next-line
  [EXPORT_PAYROLL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_PAYROLL}${param}`, { responseType: 'blob' })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) })
    })
  },

  // eslint-disable-next-line
  [EXPORT_APPROVE_PAYROLL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_APPROVE_PAYROLL}${param}`, { responseType: 'blob' })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) })
    })
  },

  // eslint-disable-next-line
  [EXPORT_INCOME_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_INCOME_DETAIL}${param}`, { responseType: 'blob' })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) })
    })
  },

  [GET_SALARY_CHART]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SALARY_CHART}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SALARY_CHART, data);
              resolve(data);
            } else {
              commit(GET_SALARY_CHART, {});
              reject(resultModel.message);
            }
          } else {
            commit(GET_SALARY_CHART, {});
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  [GET_SALARY_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SALARY_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SALARY_DETAIL, data);
              resolve(data);
            } else {
              commit(GET_SALARY_DETAIL, null);
              reject(resultModel.message);
            }
          } else {
            commit(GET_SALARY_DETAIL, null);
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  // ================================================== TICKET TEMPLATE ==========================================================================

  [GET_TICKET_LIST]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_TICKET_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_TICKET_LIST, data);
              resolve(data);
            } else {
              commit(GET_TICKET_LIST, {});
              resolve({});
            }
          } else {
            commit(GET_TICKET_LIST, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_BLOCK_LIST]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BLOCK_LIST}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BLOCK_LIST, data);
              resolve(data);
            } else {
              commit(GET_BLOCK_LIST, []);
              resolve([]);
            }
          } else {
            commit(GET_BLOCK_LIST, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [CREATE_TICKET_TEMPLATE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CREATE_TICKET_TEMPLATE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if (item.type) {
                let obj = {
                  type: item.type
                }
                dispatch(GET_TICKET_LIST, obj);
              } else {
                dispatch(GET_TICKET_LIST);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_TICKET_TEMPLATE]({ dispatch }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_TICKET_TEMPLATE}${param}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if (item.type) {
                let obj = {
                  type: item.type
                }
                dispatch(GET_TICKET_LIST, obj);
              } else {
                dispatch(GET_TICKET_LIST);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [SET_DEFAULT_TICKET_TEMPLATE]({ dispatch }, item) {
    // let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_SET_DEFAULT_TICKET_TEMPLATE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if (item.type) {
                let obj = {
                  type: item.type
                }
                dispatch(GET_TICKET_LIST, obj);
              } else {
                dispatch(GET_TICKET_LIST);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [DELETE_TICKET_TEMPLATE]({ dispatch }, item) {
    let param = new URLSearchParams(item)
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DELETE_TICKET_TEMPLATE}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if (item.type) {
                let obj = {
                  type: item.type
                }
                dispatch(GET_TICKET_LIST, obj);
              } else {
                dispatch(GET_TICKET_LIST);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        }).catch(err => reject(err))
    })
  },

  [MOVE_SUBJECT]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_MOVE_SUBJECT}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if (item.type) {
                let obj = {
                  type: item.type
                }
                dispatch(GET_TICKET_LIST, obj);
              } else {
                dispatch(GET_TICKET_LIST);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  // ===================================================================== BATCH HISTORY ==========================================================================
  [GET_BATCH_HISTORY]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BATCH_HISTORY}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BATCH_HISTORY, data);
              resolve(data);
            } else {
              commit(GET_BATCH_HISTORY, []);
              resolve([]);
            }
          } else {
            commit(GET_BATCH_HISTORY, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_BATCH_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BATCH_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BATCH_DETAIL, data);
              resolve(data);
            } else {
              commit(GET_BATCH_DETAIL, {});
              reject(resultModel.message);
            }
          } else {
            commit(GET_BATCH_DETAIL, {});
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // ===================================================================== INCOME HISTORY ==========================================================================
  [GET_INCOME_HISTORY]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_INCOME_HISTORY, { params: params })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_INCOME_HISTORY, data);
              resolve(data);
            } else {
              commit(GET_INCOME_HISTORY, []);
              resolve([]);
            }
          } else {
            commit(GET_INCOME_HISTORY, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // ===================================================================== STAFF DAILY INCOME ==========================================================================
  [GET_STAFF_DAILY_INCOME]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_STAFF_DAILY_INCOME, { params: params })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_STAFF_DAILY_INCOME, data);
              resolve(data);
            } else {
              commit(GET_STAFF_DAILY_INCOME, {});
              resolve({});
            }
          } else {
            commit(GET_STAFF_DAILY_INCOME, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
}

